import { observer } from "mobx-react";
import { observable, computed, action, autorun, toJS } from "mobx";
import { config } from "src/config";
import { authStore } from "src/modules/auth/store";

class DashboardStore {

    public fakeLayouts = {
        lg: [{
            i: String(1),
            w: 2,
            h: 2,
            x: 1,
            y: 1,
            minH: 2,
            minW: 2,
        },
        {
            i: String(2),
            w: 2,
            h: 2,
            x: 5,
            y: 5,
            minH: 2,
            minW: 2,
        }],
        md: [{
            i: String(1),
            w: 4,
            h: 2,
            x: 1,
            y: 1,
            minH: 2,
            minW: 2,
        },
        {
            i: String(2),
            w: 2,
            h: 2,
            x: 5,
            y: 5,
            minH: 2,
            minW: 2,
        }],
        sm: [{
            i: String(1),
            w: 2,
            h: 2,
            x: 1,
            y: 1,
            minH: 2,
            minW: 2,
        },
        {
            i: String(2),
            w: 2,
            h: 2,
            x: 5,
            y: 5,
            minH: 2,
            minW: 2,
        }],
        xs: [{
            i: String(1),
            w: 2,
            h: 2,
            x: 1,
            y: 1,
            minH: 2,
            minW: 2,
        },
        {
            i: String(2),
            w: 2,
            h: 2,
            x: 5,
            y: 5,
            minH: 2,
            minW: 2,
        }]
    }

    @observable
    public layout: any[];

    @observable
    public layouts: any = this.fakeLayouts;
    // public layouts: any = undefined;
    @observable
    public loaded: boolean = false;

    public mapGridToLayouts = (layout: any) => {
        // console.log(toJS(layout))
        return {
            lg: layout,
            md: layout,
            sm: layout,
            xs: layout
        }
    }

    public clearDashboard = () => {
        this.layouts = this.fakeLayouts;
        this.loaded = false;
    }


    @action
    public saveDashboardLayout = async (auth_id: number, layout: any, layouts: any, breakpoint: string | null) => {
        if (!breakpoint) {
            return
        }

        this.layouts[breakpoint] = layout;

        const response: Response = await fetch(
            config.BASE_URL + "/api/dashboard/save_layout",
            {
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
                method: "POST",
                body: JSON.stringify({
                    auth_id,
                    layouts,
                }),
            }
        );
        const responseJson = await response.json();
        this.layout = responseJson.body.dashboardWidgets
    }

    @action
    public getDashboardLayout = async (auth_id: number) => {
        const response: Response = await fetch(
            config.BASE_URL + "/api/dashboard/layout/" + auth_id,
            {
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: "",
                },
                method: "GET",
            }
        );
        const responseJson = await response.json();
        this.layout = responseJson.body.dashboardWidgets;
        this.layouts = responseJson.body.layoutObj;
        this.loaded = true;
        // this.layouts = this.mapGridToLayouts(responseJson.body);
    };
}

export default new DashboardStore();


// WEBPACK FOOTER //
// ./src/modules/dashboard/dashboard_store.ts